var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 16 16.594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8080",
    "data-name": "Grupo 8080",
    transform: "translate(1364.2 1941.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10006",
    "data-name": "Caminho 10006",
    d: "M-1355.02-1937.726c.29.135.543.244.787.37a2.317,2.317,0,0,1,1.3,1.724c.054.31-.034.424-.344.424h-5.841c-.322,0-.411-.115-.354-.431a2.325,2.325,0,0,1,1.307-1.72c.244-.127.5-.234.786-.369-.116-.164-.226-.32-.337-.475a4.063,4.063,0,0,1-.32-.447.639.639,0,0,1,.057-.7.367.367,0,0,0,.064-.2,1.655,1.655,0,0,1,1.962-1.711,1.6,1.6,0,0,1,1.48,1.714.327.327,0,0,0,.052.19.663.663,0,0,1,.036.777,3.544,3.544,0,0,1-.255.347Z",
    fill: "#415364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10007",
    "data-name": "Caminho 10007",
    d: "M-1359.722-1928.845c.32.157.609.284.885.437a2.255,2.255,0,0,1,1.2,1.7c.042.265-.052.382-.32.382q-1.243,0-2.488,0h-3.352c-.356,0-.442-.1-.379-.452a2.352,2.352,0,0,1,1.382-1.742c.216-.107.439-.2.7-.319a3.959,3.959,0,0,0-.3-.447,1.579,1.579,0,0,1-.405-.631.677.677,0,0,1,.1-.528.6.6,0,0,0,.077-.284,1.605,1.605,0,0,1,1.318-1.629,1.716,1.716,0,0,1,1.994.95,3.99,3.99,0,0,1,.132.724.464.464,0,0,0,.047.191.686.686,0,0,1,.026.823c-.076.127-.186.233-.275.353C-1359.5-1929.162-1359.611-1929-1359.722-1928.845Z",
    fill: "#415364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10008",
    "data-name": "Caminho 10008",
    d: "M-1352.667-1928.836c-.1-.156-.2-.3-.293-.446a5.591,5.591,0,0,1-.382-.547.6.6,0,0,1,.057-.608.588.588,0,0,0,.085-.281,1.581,1.581,0,0,1,1.106-1.58,1.831,1.831,0,0,1,2.006.538,1.657,1.657,0,0,1,.331,1.05.537.537,0,0,0,.08.266.681.681,0,0,1-.012.78c-.084.136-.205.248-.3.377-.106.144-.2.3-.3.443.33.163.632.294.915.457a2.247,2.247,0,0,1,1.166,1.72.265.265,0,0,1-.281.341c-.028,0-.057,0-.086,0h-5.8c-.352,0-.434-.1-.374-.439a2.38,2.38,0,0,1,1.449-1.788C-1353.106-1928.647-1352.9-1928.731-1352.667-1928.836Z",
    fill: "#415364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10009",
    "data-name": "Caminho 10009",
    d: "M-1363.32-1932.079a7.13,7.13,0,0,1,3.059-5.6c.115-.083.244-.143.361-.037a.332.332,0,0,1,.1.251.369.369,0,0,1-.16.206,6.621,6.621,0,0,0-2.166,2.532,6.523,6.523,0,0,0-.674,2.8.9.9,0,0,1-.006.155.24.24,0,0,1-.267.215.235.235,0,0,1-.241-.225A2.622,2.622,0,0,1-1363.32-1932.079Z",
    fill: "#415364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10010",
    "data-name": "Caminho 10010",
    d: "M-1356.305-1924.688a7.029,7.029,0,0,1-3.06-.748c-.082-.041-.184-.11-.206-.187a.358.358,0,0,1,.065-.278c.078-.1.2-.073.317-.026a12.131,12.131,0,0,0,1.27.482,6.5,6.5,0,0,0,4.822-.526c.026-.014.05-.029.077-.041a.262.262,0,0,1,.359.1.248.248,0,0,1-.118.35c-.352.169-.7.343-1.071.476A7.048,7.048,0,0,1-1356.305-1924.688Z",
    fill: "#415364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10011",
    "data-name": "Caminho 10011",
    d: "M-1349.054-1932.149c0,.1,0,.2,0,.293,0,.191-.1.3-.258.3s-.254-.108-.257-.3a6.636,6.636,0,0,0-.826-3.158,6.559,6.559,0,0,0-1.984-2.222c-.029-.02-.057-.039-.084-.061a.258.258,0,0,1-.08-.362.253.253,0,0,1,.367-.058,7.914,7.914,0,0,1,.682.526,7.062,7.062,0,0,1,2.421,4.9c0,.046.006.092.009.138Z",
    fill: "#415364"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.2973c36a0a107ba2da17d366b08ee6ff.svg";
export { ForwardRef as ReactComponent };